import "./App.css";
import { useStateFields } from './store/hooks';
import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import AlbumView from "./components/AlbumView/AlbumView";
import PortfolioAlbumView from './components/PortfolioAlbumView/PortfolioAlbumView';
import PortfolioVideoView from './components/PortfolioVideoView/PortfolioVideoView';
import GuestUpload from "./pages/GuestUpload/GuestUpload";
import EGQuotation from './pages/EGQuotation/Quotation';
import WGQuotation from './pages/WGQuotation/Quotation';
import WorkDetailWrapper from "./pages/WorkDetail/WorkDetailWrapper";
import Ratings from "./components/Ratings/Ratings";
import EGNonWeddingQuotation from './pages/EGNonWeddingQuotation/NonWeddingQuotation'
import VideoView from "./components/VideoView/VideoView";
import WGNonWeddingQuotation from './pages/WGNonWeddingQuotation/NonWeddingQuotation'
import { Platform, getAPIUrl, isAdmin ,setupApiFailureGuard} from "./script/util"
import DownloadZip from "./components/DownloadZip/DownloadZip";
import ShareUrls from "./pages/Share-Urls/ShareUrls";
import posthog from 'posthog-js';
import Activity from "./pages/Activity/Activity";
import Portfolio from "./pages/portfolio/Portfolio";
import QuoteForm from "./pages/QuoteForm/QuoteForm";
import RegisterSelfie from "./pages/RegisterSelfie/RegisterSelfie";
import Account from "./pages/Account/Acccount.js";
import Referral from "./pages/Referral/Referral.jsx";
import Wallet from "./pages/Wallet/Wallet";
import CustomStatus from "./components/CustomStatus/CustomStatus.jsx";
import CreativePreferences from "./pages/CreativePreferences/CreativePreferences";
import CreativeFormPreview from "./pages/CreativePreferences/CreativeFormPreview";

// Loaded on its own: the form carries the face detector, which no other
// page here needs.
const WeddingDay = lazy(() => import("./pages/WeddingDay/WeddingDay"));
const WhatToExpect = lazy(() => import("./pages/WhatToExpect/WhatToExpect"));
const BookingNotes = lazy(() => import("./pages/BookingNotes/BookingNotes"));


function App() {
  const { blocked, setBlocked } = useStateFields(['blocked']);
  const isGuardEnabled = process.env.REACT_APP_DISABLE_API_GUARD !== 'true';
  
    setupApiFailureGuard({
    onBlock: () =>setBlocked(true),
    enabled: isGuardEnabled,
        });

  const getRemainingTime = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem("api_guard_state")) || {};
      const now = Date.now();
      let maxBlockedUntil = 0;

      for (const url in state) {
        if (state[url].blockedUntil && state[url].blockedUntil > maxBlockedUntil) {
          maxBlockedUntil = state[url].blockedUntil;
        }
      }

      if (maxBlockedUntil > now) {
        return Math.ceil((maxBlockedUntil - now) / 1000);
      }
      return 0;
    } catch (e) {
      return 0;
    }
  };

  const [timeLeft, setTimeLeft] = useState(getRemainingTime());

  useEffect(() => {
    if (blocked) {
      setTimeLeft(getRemainingTime()); 

      const timer = setInterval(() => {
        const remaining = getRemainingTime();
        setTimeLeft(remaining);

        if (remaining <= 0) {
          clearInterval(timer);
          if (setBlocked) setBlocked(false);
        }
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [blocked]);

  useEffect(() => {
  try {
    const state = JSON.parse(sessionStorage.getItem("api_guard_state")) || {};
    const now = Date.now();
    for (const url in state) {
      if (state[url].blockedUntil && state[url].blockedUntil > now) {
        setBlocked(true);
        break;
      }
    }
  } catch (e) {
    console.error(e);
  }
}, []);

  const { setPosthogEvents, setPages, posthogEvents, setPhTrack, buttonEventMap, setButtonEventMap, scrollEventMap, setScrollEventMap } = useStateFields(['posthogEvents', 'buttonEventMap', 'scrollEventMap']);
  React.useEffect(() => {
    if (Platform.isWG) {
      document.title = 'WedGraphia'
      var favicon_links = `
      <link rel="apple-touch-icon" sizes="57x57"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16"
          href="https://assets.graphia.in/site_media/wedgraphia/logo/black16x16.png" />`
      document.head.insertAdjacentHTML('beforeend', favicon_links);
    } else {
      document.title = 'EventGraphia'
      var favicon_links = `
      <link rel="apple-touch-icon" sizes="57x57"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249972/webapp/favicon/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16"
        href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-16x16.png" />`
      document.head.insertAdjacentHTML('beforeend', favicon_links)
    }
  }, [])

  const fetchConstants = async () => {
      try {
        const response = await fetch(getAPIUrl('/api/analytics/posthog/event_map'));
        const data = await response.json();
        setPosthogEvents(data.posthog_events || {});
        setPages(data.pages || {});
        setButtonEventMap(data.button_event_map || {});
        setScrollEventMap(data.scroll_event_map || {});
        setPhTrack(data.ph_track || {});
      } catch (error) {
        console.error('Failed to load constants:', error);
      }
  };



  useEffect(() => {
    fetchConstants();
  }, []);

  useEffect(() => {
    if (isAdmin() || !posthogEvents || Object.keys(posthogEvents).length === 0) return;

    const observer = new MutationObserver(() => {
      const elements = document.querySelectorAll('.track-action');
      elements.forEach((el) => {
        var phType = el.getAttribute('ph-type');
        if (!phType) return;
        const [pageKey, actionKey] = phType.split('|');
        const eventData = buttonEventMap?.[pageKey]?.[actionKey];
        const ph_data = {};

        if (eventData && !el.dataset.phClickTracked) {
          el.dataset.phClickTracked = 'true';
          el.addEventListener('click', () => {
            eventData.props.forEach((prop) => {
              ph_data[prop] = el.getAttribute(prop);
            });

            posthog.capture(eventData.event, ph_data);
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

  }, [posthogEvents]);

  return (
      <div className="App">
        <Router>
          <Routes>
            <Route path="/:id?" element={<Dashboard />}></Route>
            <Route path="/wallet" element={<Wallet />}></Route>
            <Route path="/account" element={<Account />}></Route>
            <Route path="/referral" element={<Referral />}></Route>
            {/* The page's old path, kept for links already shared. */}
            <Route path="/referral-c-1" element={<Referral />}></Route>
            <Route path="/share-url-list" element={<ShareUrls />}></Route>
            <Route path="/album" element={<AlbumView />}></Route>
            <Route path='/portfolio-video' element={<PortfolioVideoView />}></Route>
            <Route path='/portfolio-album' element={<PortfolioAlbumView />}></Route>
            <Route path="/guestupload" element={<GuestUpload />}></Route>
            <Route path='/video' element={<VideoView/>}></Route>
            <Route path='work-details/:id?' element={<WorkDetailWrapper />}></Route>
            <Route path='download/:key' element={<DownloadZip/>}></Route>
            <Route path='ratings/:id?' element={<Ratings/>}></Route>
            <Route path='/activity' element={<Activity/>}></Route>
            <Route path='/portfolio/:slug?' element={<Portfolio/>}></Route>
            <Route path='/quote-form/:id?' element={<QuoteForm />}></Route>
            <Route path='/:booking_pk/registerselfie' element={<RegisterSelfie />}></Route>
            <Route path='/booking/:booking_id/creative-preferences' element={<CreativePreferences />}></Route>
            <Route path='/creative-form-preview' element={<CreativeFormPreview />}></Route>
            <Route path='/booking/:booking_id/wedding-day' element={<Suspense fallback={null}><WeddingDay /></Suspense>}></Route>
            <Route path='/booking/:booking_id/what-to-expect' element={<Suspense fallback={null}><WhatToExpect /></Suspense>}></Route>
            <Route path='/booking/:booking_id/notes' element={<Suspense fallback={null}><BookingNotes /></Suspense>}></Route>
            {Platform.isWG ? (
              <>
                <Route path='/quotation' element={<WGQuotation />}></Route>
                <Route path='/proposal' element={<WGQuotation />}></Route>
                <Route path='/quotation-preview' element={<WGQuotation preview={true} />}></Route>
                <Route path='/quote' element={<WGNonWeddingQuotation />}></Route>
                <Route path='/quote-preview' element={<WGNonWeddingQuotation preview={true} />}></Route>
              </>
            ) : (
              <>
                <Route path='/quotation' element={<EGQuotation />}></Route>
                <Route path='/proposal' element={<EGQuotation />}></Route>
                <Route path='/quotation-preview' element={<EGQuotation preview={true} />}></Route>
                <Route path='/quote' element={<EGNonWeddingQuotation />}></Route>
                <Route path='/quote-preview' element={<EGNonWeddingQuotation preview={true} />}></Route>
              </>
            )}
          </Routes>
      {
        blocked && <CustomStatus  errorMessage={`Resuming in ${timeLeft}s`}/>
      }
        </Router>
      </div>
  );
}

export default App;
